import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import STEPS from '../../constants/STEPS';

interface ChangeStepPayload {
  step: number;
}

interface State {
  step: number;
  feedbackComponent?: string;
}

const initialState: State = {
  step: STEPS.PLANS_SELECTION,
  feedbackComponent: null,
};

const page = createSlice({
  name: 'page',

  initialState,

  reducers: {
    setStep(state, action: PayloadAction<number>) {
      state.step = action.payload;
    },

    setFeedbackComponent(state, action: PayloadAction<string>) {
      state.feedbackComponent = action.payload;
    },
  },
});

export const {
  setStep,
  setFeedbackComponent,
} = page.actions;

export default page.reducer;
